import { getPreferences, init, onPreferencesChanged } from "cookie-though";

gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
});

function cookiesEnabled(prefs, category) {
    var tmp = prefs.cookieOptions.find((x) => x.id === category);
    if (tmp && tmp.isEnabled) return "granted";
    else return "denied";
}

if (window.cookiePolicy) {
    init(window.cookiePolicy);

    var style = document.createElement("style");
    style.innerHTML = `
    .ct-button { border-radius: 9999px; border: 1px solid black; background: #000000; color: white; padding: 1rem 2rem !important; margin-left: 0 !important; font-size: 12px;} 
    .ct-banner-intro {margin-bottom: 1.5rem;}
    .ct-customization-button {font-size: 11px;}
    .ct-button:hover {background: white; color: black;}
    .ct-acceptance {display: flex; flex-direction: row-reverse; justify-content: flex-end;}
    .ct-button-secondary {display: none !important;}
    .ct-button-secondary:hover {background: white; color: black; text-decoration: underline;}
    `;

    document.querySelector(".cookie-though").shadowRoot.appendChild(style);

    onPreferencesChanged((prefs) => {
        console.log("Cookie prefs changed", prefs);

        gtag("consent", "update", {
            ad_storage: cookiesEnabled(prefs, "advertising"),
            analytics_storage: cookiesEnabled(prefs, "statistics"),
        });
    });

    var initialPrefs = getPreferences();
    if (initialPrefs) {
        console.log("Initial cookie prefs", initialPrefs);

        gtag("consent", "update", {
            ad_storage: cookiesEnabled(initialPrefs, "advertising"),
            analytics_storage: cookiesEnabled(initialPrefs, "statistics"),
        });
    }
}
